import React from 'react';

import { Flex } from '@lucidhq/lucidium';

import { CreativesNumberField } from './CreativesNumberField';
import { SampleSizeField } from './SampleSizeField';

export const CREATIVES_NUMBER_FIELD_NAME =
  'draft_settings.forced_exposure.creatives_number';
export const SAMPLE_SIZE = 'draft_settings.forced_exposure.exposed_sample_size';

export const ForcedExposureSection = () => {
  return (
    <Flex id="creative-information" lss={{ flexDirection: 'column' }}>
      <Flex lss={{ flexDirection: 'column', my: 'md' }}>
        <CreativesNumberField name={CREATIVES_NUMBER_FIELD_NAME} />

        <SampleSizeField name={SAMPLE_SIZE} />
      </Flex>
    </Flex>
  );
};
